// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionWriters_section__lU7gY","heading":"SectionWriters_heading__n_Ryp"};